export default {
  law: {
    title: '特定商取引法に基づく表記',
    serviceName: '服務名稱',
    companyName: '銷售業者',
    representative: '代表者姓名',
    address: '所在地',
    contact: '諮詢處',
    paymentTerms: '付款方式及付款時間',
    deliverySchedule: '商品交付時間',
    sellingPrice: '商品等的銷售價格',
    shippingFee: '運費',
    additionalFee: '銷售價格・運費等以外的必要費用',
    salesRestrictions: '銷售期間・銷售數量的限制',
    returnsAndCancellations: '退貨・取消',
    otherConditions: '其他條件'
  }
};
